/* global google */

class ForgotPasswordController {
    /**
     * @param $state
     * @param authService
     */
    constructor($window, $state, authService) {
        this.authService = authService;
        this.$state = $state;
        this.$window = $window;
        this.credentials = {};
        this.isSend = false;
    }

    $onInit() {
        if(!this.authService.userIsNotAuthenticated()) {
            this.$state.go('home');
        }
    }

    submitEmail() {
        this.authService.forgotPassword(this.credentials.email).then(() => this.isSend = true);
    }

    goToLogin() {
        this.$window.location.href = '/login';
    }
}

ForgotPasswordController.$inject = ['$window', '$state', 'AuthService'];

export default ForgotPasswordController;



// WEBPACK FOOTER //
// ./src/app/pages/login/forgotPassword/forgotPasswordController.js